import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import RentalDamageReportListScreen from './screens/RentalDamageReportListScreen';

function RentalDamageReports() {
  return (
    <KT01BaseLayout isFullScreen>
      <div className="container-fluid px-0">
        <Routes>
          <Route path="" element={<RentalDamageReportListScreen />} />
          <Route path="*" element={<>Đường dẫn không hợp lệ</>} />
        </Routes>
      </div>
    </KT01BaseLayout>
  );
}

export default RentalDamageReports;
